import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";

const getDataVessel = async (type = '') => {
    const URL = `/Vessel/GetDataVessels?type=${type}`;
    return apiCall('get', URL);
};

const getListVessel = async (param: any) => {
    const query = `?id=${param.id}&search=${param.search}&status=${param.status}&type=${param.type}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/Vessel/GetAllVessels${query}`;
    return apiCall('get', URL);
};

const getVesselById = async (id: string) => {
    const URL = `/Vessel/GetVesselById/${id}`;
    return apiCall('get', URL);
};

const putVessel = async (data: any) => {
    const URL = '/Vessel/Update';
    // return apiCall('post', URL, data);
    try {
        const response = await axiosInstance.post<any[]>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const postVessel = async (data: any) => {
    const URL = '/Vessel/Create';
    return apiCall('post', URL, data);
};

const updateStatusVessel = async (data: any) => {
    const URL = '/Vessel/UpdateStatus';
    return apiCall('post', URL, data);
};

const deleteVessel = async (data: any) => {
    const URL = '/Vessel/Delete';
    return apiCall('post', URL, data);
};

const checkStatusInvoiceByVesselId = async (id: string) => {
    const URL = `/InvoiceInspectors/GetInspectorInvoiceByVesselId/${id}`;
    return apiCall('get', URL);
}

export {
    deleteVessel,
    postVessel,
    putVessel,
    getVesselById,
    getListVessel,
    getDataVessel,
    updateStatusVessel,
    checkStatusInvoiceByVesselId
}